import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import {createMuiTheme,MuiThemeProvider} from "@material-ui/core/styles";
export default function InfoToolTip(props) {
  const { content, title,color,bgColor,borderColor } = props;
  const theme = createMuiTheme({
    overrides: {
      MuiTooltip: {
        tooltip: {
          backgroundColor: bgColor,
          color:color,
        },
        popper: {
          backgroundColor: bgColor,
          border: `solid 1px ${borderColor}`,
          borderRadius: '4px',
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
          color: color
        },
        tooltipPlacementTop:{
          margin:'5px 0px !important',
        },
        tooltipPlacementBottom:{
          margin:'5px 0px !important',
        }
      }
    }
  });
  return (
    <MuiThemeProvider theme={theme}>
      <Tooltip title={content} interactive>
        <span>{title}</span>
      </Tooltip>
    </MuiThemeProvider>
  );
}